import { FC, useState, useRef } from 'react';
import DatePicker from "react-datepicker";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/datepicker.css'
import closeBtn from '../../../assets/images/close-btn.svg';

interface Props {
    step: number,
    closeModal: () => void
    selectDate: (date: Date[]) => void
    handleBBDateSelection: (dates?: Date[]) => void
}

const BeginningBalanceImportModal: FC<Props> = ({ step, closeModal, selectDate, handleBBDateSelection }) => {

    const calendarRef = useRef<any>(null);
    const startCalendarRef = useRef<any>(null);
    const endCalendarRef = useRef<any>(null);
        // Initialize state with localStorage data if in step 3
    const getInitialDate = (): Date[] => {
        if (step === 3) {
            const storedDate = localStorage.getItem('bbSelectedDate');
            if (storedDate) {
                try {
                    const parsedDate = JSON.parse(storedDate);
                    const rawDateStr = Array.isArray(parsedDate) ? parsedDate[0] : parsedDate;
                    if (rawDateStr) {
                        const startDate = moment(rawDateStr).add(1, 'day').startOf('month').toDate();
                        return [
                            startDate,
                            moment().endOf('month').toDate()
                        ];
                    }
                } catch (error) {
                    console.error('Error parsing stored date:', error);
                }
            }
        }
        
        return [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().endOf('month').toDate()
        ];
    };
    const [selectedDate, setSelectedDate] = useState<Date[]>(getInitialDate());
    const [isReconciledConfirmed, setIsReconciledConfirmed] = useState<boolean>(false);
    const [maxDate, setMaxDate] = useState<Date>(selectedDate[0])
    const { t, i18n } = useTranslation("components.Modal.BeginningBalanceImportModal");
    const formatMonth = (d?: Date) => d ? moment(d).toDate().toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' }) : t("notice.selectedMonth");

    const _handleSelectDate = (date: Date[]) => {
        if(step === 2){
            localStorage.setItem('bbSelectedDate', JSON.stringify(date))
        }
        setIsReconciledConfirmed(false);
        setSelectedDate(date)
        selectDate(date);
    }

    const openCalendar = () => {
        if (calendarRef.current) {
            calendarRef.current?.setOpen(true)
        }
    }
    const startOpenCalendar = () => {
        if (startCalendarRef.current) {
            startCalendarRef.current?.setOpen(true)
        }
    }
    const endOpenCalendar = () => {
        if (endCalendarRef.current) {
            endCalendarRef.current?.setOpen(true)
        }
    }

    const _handleSubmitModal = () => {
        if (selectedDate) {
            selectDate(selectedDate);
            handleBBDateSelection(selectedDate);
            closeModal();
        }
    }

    const _handleCloseModal = () => {
        closeModal();
        selectDate([]);
    }

    /*useEffect(() => {
        if (step == 3) {
            const maxdate = selectedDate[0] ? moment(selectedDate[0]).add(5, 'months').endOf('month').toDate() : moment().subtract(1, 'month').endOf('month').toDate();

            const currentDate = moment().startOf('month');
            const maxdateDate = moment(maxdate);

            if (moment(maxdateDate).isBefore(currentDate)) {
                setMaxDate(maxdate);
                setSelectedDate([selectedDate[0], maxdate]);
                selectDate([selectedDate[0], maxdate]);
            } else {
                setMaxDate(moment(currentDate).subtract(1, 'day').toDate());
                setSelectedDate([selectedDate[0], moment(currentDate).subtract(1, 'day').toDate()]);
                selectDate([selectedDate[0], moment(currentDate).subtract(1, 'day').toDate()]);
            }
        }
    }, [selectedDate[0]])*/

    return (
        <Modal show={true} onHide={_handleCloseModal} backdrop="static" animation={false} size="lg">
            <div className="">
                <div className="">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{step == 2 ? t("modal.title.importBB") : step == 3 ? t("modal.title.importBSPL") : ''}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label={t("button.close")} onClick={_handleCloseModal}><img src={closeBtn} alt="" /></button>
                    </div>
                    <div className="modal-body pb-0">
                        {
                            step == 2 ? (
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group date-picker-container">
                                            <label htmlFor="">{t("label.selectDate")}<strong className='text-danger'>*</strong></label>
                                            <DatePicker
                                                ref={calendarRef}
                                                selected={moment(selectedDate[0]).endOf('month').toDate()}
                                                onChange={(date: Date) => _handleSelectDate([date])}
                                                className='form-control'
                                                dateFormat={'MM/dd/yyyy'}
                                                maxDate={moment().subtract(1, 'month').endOf('month').toDate()}
                                                showMonthYearPicker
                                                calendarIconClassname='tex-end'
                                                onKeyDown={(e) => e.preventDefault()}
                                            />

                                            <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={openCalendar}></i>
                                        </div>
                                    </div>
                                </div>
                            ) : step == 3 ? (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="filter-wrap">
                                            <div className="d-flex">
                                                <div className="form-group date-picker-container">
                                                    <label htmlFor="">{t("label.startDate")}</label>
                                                    <DatePicker
                                                        ref={startCalendarRef}
                                                        selected={moment(selectedDate[0]).toDate()}
                                                        onChange={(date: Date) => _handleSelectDate([date, selectedDate[1]])}
                                                        className='form-control'
                                                        dateFormat={'MM/dd/yyyy'}
                                                        disabled={true}
                                                        maxDate={moment().subtract(1, 'month').endOf('month').toDate()}
                                                        calendarIconClassname='tex-end'
                                                        showYearDropdown
                                                        scrollableYearDropdown
                                                        yearDropdownItemNumber={40}
                                                        showMonthDropdown
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />

                                                    <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={startOpenCalendar}></i>
                                                </div>
                                                &nbsp;&nbsp;&nbsp;

                                                <div className="form-group date-picker-container">
                                                    <label htmlFor="">{t("label.endDate")}</label>
                                                    <DatePicker
                                                        ref={endCalendarRef}
                                                        selected={moment(selectedDate[1]).endOf('month').toDate()}
                                                        onChange={(date: Date) => _handleSelectDate([selectedDate[0], moment(date).endOf('month').toDate()])}
                                                        className='form-control'
                                                        dateFormat={'MM/dd/yyyy'}
                                                        // minDate={moment(selectedDate[0]).startOf('month').toDate()}
                                                        // maxDate={maxDate}
                                                        maxDate={moment().endOf('month').toDate()}
                                                        calendarIconClassname='tex-end'
                                                        showMonthYearPicker
                                                        onKeyDown={(e) => e.preventDefault()}
                                                    />

                                                    <i className="fa fa-calendar fa-2xl cursor-pointer calendar-icon" aria-hidden="true" onClick={endOpenCalendar}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-12">
                                        <small className="text-muted">
                                            <i className="fa fa-exclamation-triangle text-warning me-1" data-bs-toggle="tooltip" data-bs-placement="top"></i>
                                            {t("info.maxMonths")}
                                        </small>
                                    </div> */}
                                </div>
                            ) : <></>
                        }

                        {/* --- QBO RECONCILED DATA CONFIRMATION NOTICE & CHECKBOX --- */}
                        {step >= 2 && (
                            <div className="mt-3">
                                <div className="p-3 rounded-3 border" style={{ backgroundColor: '#fffbe6', borderColor: '#ffe58f' }}>
                                    <div className="d-flex align-items-start gap-2">
                                        <i className="fas fa-exclamation-triangle text-warning mt-1" style={{ fontSize: '20px' }} aria-hidden="true"></i>
                                        <div>
                                            <strong className="text-dark d-block mb-1" style={{ fontSize: '16px', fontWeight: 700 }}>
                                                {t("notice.title")}
                                            </strong>
                                            <span className="text-dark d-block" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                                                {t("notice.body")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {/* This checkbox gates Continue, so it has to read as a required action
                                    rather than a grey note: amber while outstanding, green once confirmed. */}
                                <div
                                    className="form-check mt-3 mb-2 p-3 rounded d-flex align-items-center gap-2"
                                    style={{
                                        border: `2px solid ${isReconciledConfirmed ? '#16a34a' : '#f59e0b'}`,
                                        backgroundColor: isReconciledConfirmed ? '#f0fdf4' : '#fffbeb',
                                        transition: 'background-color .15s ease, border-color .15s ease',
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        className="form-check-input ms-1"
                                        id="reconciledConfirmCheckbox"
                                        checked={isReconciledConfirmed}
                                        onChange={(e) => setIsReconciledConfirmed(e.target.checked)}
                                        style={{
                                            cursor: 'pointer',
                                            width: '22px',
                                            height: '22px',
                                            marginTop: 0,
                                            flexShrink: 0,
                                            accentColor: '#16a34a',
                                            borderColor: isReconciledConfirmed ? '#16a34a' : '#f59e0b',
                                            borderWidth: '2px',
                                        }}
                                    />
                                    <label className="form-check-label font-weight-600 text-dark mb-0 cursor-pointer" htmlFor="reconciledConfirmCheckbox" style={{ cursor: 'pointer', fontSize: '14px', lineHeight: '1.4' }}>
                                        {t("notice.confirm", { month: formatMonth(step === 2 ? selectedDate[0] : selectedDate[1]) })}
                                        {!isReconciledConfirmed && (
                                            <span className="badge ms-2 align-middle" style={{ backgroundColor: '#f59e0b', color: '#fff', fontSize: '11px' }}>
                                                {t("notice.required")}
                                            </span>
                                        )}
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" onClick={_handleCloseModal}>{t("button.close")}</button> &nbsp;
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={_handleSubmitModal}
                            disabled={!isReconciledConfirmed}
                        >
                            {t("button.continue")}
                        </button>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </Modal>
    )
}

export default BeginningBalanceImportModal;